import { Form, InputProps } from 'rsuite';

interface TextFieldProps extends InputProps {
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accepter: any;
  hideLabel?: boolean;
  formGroupStyle?: React.CSSProperties;
}

export default function TextField(props: TextFieldProps) {
  const { name, label, accepter, hideLabel, formGroupStyle, ...rest } = props;
  return (
    <Form.Group controlId={`${name}`} style={formGroupStyle} className="mt-3 max-w-[100%]">
      {hideLabel ? null : <Form.ControlLabel className="text-sm">{label}</Form.ControlLabel>}
      <Form.Control name={name} accepter={accepter} className="w-[100%]" {...rest} />
    </Form.Group>
  );
}
